import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { deepMix } from '@antv/util';
import { isUnset } from '../utils/helper';
import { columnOf } from './utils/helper';
/**
 * Infer title channel from x-position channel.
 */
export var MaybeTitle = function MaybeTitle() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$channel = options.channel,
    channel = _options$channel === void 0 ? 'x' : _options$channel;
  return function (I, mark) {
    var encode = mark.encode;
    var tooltip = mark.tooltip;
    if (isUnset(tooltip)) return [I, mark];
    var title = tooltip.title;
    if (title !== undefined) return [I, mark];
    var titles = Object.keys(encode).filter(function (key) {
      return key.startsWith(channel);
    }).filter(function (key) {
      return !encode[key].inferred;
    }).map(function (key) {
      return columnOf(encode, key);
    }).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        T = _ref2[0];
      return T;
    }).map(function (d) {
      return d[0];
    });
    if (titles.length === 0) return [I, mark];
    var T = [];
    var _iterator = _createForOfIteratorHelper(I),
      _step;
    try {
      var _loop = function _loop() {
        var i = _step.value;
        T[i] = {
          value: titles.map(function (t) {
            return t[i];
          }).join(', ')
        };
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [I, deepMix({}, mark, {
      tooltip: {
        title: T
      }
    })];
  };
};
MaybeTitle.props = {};